import React, {useState} from "react";
import {useLocation} from "react-router";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {backgroundColor, color, m, mb, onDesktop, p, resetWidth, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {parseSearch} from "@pg-mono/request";
import {pluralize} from "@pg-mono/string-utils";

import {useRedirectedAuth} from "../../../auth/hooks/use_redirected_auth";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {ViewType} from "../../../view_type/ViewType";
import {IArticleCommentStore} from "../../reducers/article_comment_reducer";
import {ArticleRating} from "../article_detail/ArticleRating";
import {ArticleContainer} from "../ArticleContainer";
import {ArticleCommentForm} from "./ArticleCommentForm";
import {ArticleCommentList} from "./ArticleCommentList";

interface IProps {
    article: {
        id: number;
        ratings: {
            average: number | null;
            total: number;
        };
    };
    comments: IArticleCommentStore;
}

export const ArticleComments: React.FC<IProps> = (props) => {
    const {article, comments} = props;

    const commentsPluralize = pluralize(["Komentarz", "Komentarze", "Komentarzy"]);
    const commentCount = comments.list?.length ?? 0; // required at least one comment to be visible on desktop. On mobile this count is irrelevant, comments are shown unconditionally.

    const theme = useTheme();
    const darkGrayBackground = backgroundColor(theme.colors.gray[200]);
    const grayText = color(theme.colors.gray[700]);

    const location = useLocation();

    const query = parseSearch(location.search);
    // If query contains `referer` param with value `ViewType.ARTICLE` this mean that user was redirected here with oauth flow.
    // In such case we should show comment form.
    const [isFormShown, setIsFormShown] = useState(query.referer === ViewType.ARTICLE || false);

    const {onRedirectedLogin} = useRedirectedAuth();

    const isAuthenticated = useIsAuthenticated();

    const onShowCommentForm = () => {
        isAuthenticated ? setIsFormShown(true) : onRedirectedLogin({referer: ViewType.ARTICLE});
    };

    return (
        <>
            <ArticleContainer>
                <div css={[p(10, 0, 4, 0), blogArticleContainer]}>
                    <ArticleRating
                        css={css`
                            justify-content: flex-start;
                        `}
                        articleId={article.id}
                        ratings={article.ratings}
                        isHorizontal
                    />
                </div>
            </ArticleContainer>
            <div css={[darkGrayBackground, p(4, 0, 4, 0), onDesktop(p(4, 0, 7, 0))]}>
                <ArticleContainer>
                    <div css={blogArticleContainer}>
                        <div css={commentDataPanel}>
                            <div>
                                {!!commentCount && (
                                    <Text css={mb(2)} variant="headline_6" as="p">
                                        {commentCount} {commentsPluralize(commentCount)}
                                    </Text>
                                )}
                                <Text css={[grayText, mb(2), onDesktop(mb(0))]} as="div" variant="body_copy_2">
                                    Komentowanie dostępne tylko dla zalogowanych użytkowników.
                                </Text>
                            </div>

                            {!isFormShown && (
                                <Button css={[w100, mb(5), onDesktop(resetWidth, mb(0))]} onClick={onShowCommentForm} variant="filled_primary">
                                    skomentuj
                                </Button>
                            )}
                        </div>

                        {isFormShown && <ArticleCommentForm css={m(4, 0, 4, 0)} articleID={props.article.id} />}
                        <ArticleCommentList comments={props.comments.list ?? []} />
                    </div>
                </ArticleContainer>
            </div>
        </>
    );
};

const blogArticleContainer = css`
    margin-left: auto;
`;

const commentDataPanel = css`
    ${mb(4)};
    ${onDesktop(css`
        display: flex;
        justify-content: space-between;
    `)}
`;
import React, {useState} from "react";
import {useLocation} from "react-router";
import {css, useTheme} from "@emotion/react";

import {Button} from "@pg-design/button-module";
import {backgroundColor, color, m, mb, onDesktop, p, resetWidth, w100} from "@pg-design/helpers-css";
import {Text} from "@pg-design/text-module";
import {parseSearch} from "@pg-mono/request";
import {pluralize} from "@pg-mono/string-utils";

import {useRedirectedAuth} from "../../../auth/hooks/use_redirected_auth";
import {useIsAuthenticated} from "../../../user/hooks/use_is_authenticated";
import {ViewType} from "../../../view_type/ViewType";
import {IArticleCommentStore} from "../../reducers/article_comment_reducer";
import {ArticleRating} from "../article_detail/ArticleRating";
import {ArticleContainer} from "../ArticleContainer";
import {ArticleCommentForm} from "./ArticleCommentForm";
import {ArticleCommentList} from "./ArticleCommentList";

interface IProps {
    article: {
        id: number;
        ratings: {
            average: number | null;
            total: number;
        };
    };
    comments: IArticleCommentStore;
}

export const ArticleComments: React.FC<IProps> = (props) => {
    const {article, comments} = props;

    const commentsPluralize = pluralize(["Komentarz", "Komentarze", "Komentarzy"]);
    const commentCount = comments.list?.length ?? 0; // required at least one comment to be visible on desktop. On mobile this count is irrelevant, comments are shown unconditionally.

    const theme = useTheme();
    const darkGrayBackground = backgroundColor(theme.colors.gray[200]);
    const grayText = color(theme.colors.gray[700]);

    const location = useLocation();

    const query = parseSearch(location.search);
    // If query contains `referer` param with value `ViewType.ARTICLE` this mean that user was redirected here with oauth flow.
    // In such case we should show comment form.
    const [isFormShown, setIsFormShown] = useState(query.referer === ViewType.ARTICLE || false);

    const {onRedirectedLogin} = useRedirectedAuth();

    const isAuthenticated = useIsAuthenticated();

    const onShowCommentForm = () => {
        isAuthenticated ? setIsFormShown(true) : onRedirectedLogin({referer: ViewType.ARTICLE});
    };

    return (
        <>
            <ArticleContainer>
                <div css={[p(10, 0, 4, 0), blogArticleContainer]}>
                    <ArticleRating
                        css={css`
                            justify-content: flex-start;
                        `}
                        articleId={article.id}
                        ratings={article.ratings}
                        isHorizontal
                    />
                </div>
            </ArticleContainer>
            <div css={[darkGrayBackground, p(4, 0, 4, 0), onDesktop(p(4, 0, 7, 0))]}>
                <ArticleContainer>
                    <div css={blogArticleContainer}>
                        <div css={commentDataPanel}>
                            <div>
                                {!!commentCount && (
                                    <Text css={mb(2)} variant="headline_6" as="p">
                                        {commentCount} {commentsPluralize(commentCount)}
                                    </Text>
                                )}
                                <Text css={[grayText, mb(2), onDesktop(mb(0))]} as="div" variant="body_copy_2">
                                    Komentowanie dostępne tylko dla zalogowanych użytkowników.
                                </Text>
                            </div>

                            {!isFormShown && (
                                <Button css={[w100, mb(5), onDesktop(resetWidth, mb(0))]} onClick={onShowCommentForm} variant="filled_primary">
                                    skomentuj
                                </Button>
                            )}
                        </div>

                        {isFormShown && <ArticleCommentForm css={m(4, 0, 4, 0)} articleID={props.article.id} />}
                        <ArticleCommentList comments={props.comments.list ?? []} />
                    </div>
                </ArticleContainer>
            </div>
        </>
    );
};

const blogArticleContainer = css`
    margin-left: auto;
`;

const commentDataPanel = css`
    ${mb(4)};
    ${onDesktop(css`
        display: flex;
        justify-content: space-between;
    `)}
`;
